import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ModalExitComponent } from '../../shared/components/modal/modal-exit/modal-exit.component';
import { MatDialog } from '@angular/material/dialog';
import { ClientsService } from '../../services/clients.service';

import { Module } from '../../models/module.model';
import { NavItem } from '../menu-list-item/navItem';
import { Store } from '@ngrx/store';
// import { AppState } from 'src/app/store/reducers';
// import { AuthActions } from 'src/app/auth/store/action-types';
// import {
//   selectCompany,
//   selectModules,
// } from '../../modules/company/store/company.selectors';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {AppState} from "../../store/app.state";
// import {AuthActions} from "../../auth/store/action-types";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  sidebarOpened = false;
  myActiveModules: Module[] = [];
  navItems: NavItem[] = [
    {
      displayName: 'sidebar.company',
      iconName: 'business',
      route: '/company',
    },
    {
      displayName: 'sidebar.offices',
      iconName: 'store',
      route: '/offices',
    },
    {
      displayName: 'sidebar.subscriptions',
      iconName: 'subscriptions',
      route: '/subscriptions',
    },
    {
      displayName: 'sidebar.users',
      iconName: 'groups',
      route: '/users/list',
      exactPath: true,
    },
    {
      displayName: 'sidebar.premium',
      iconName: 'add_shopping_cart',
      route: '/awards',
      exactPath: false,
      children: [
        {
          displayName: 'sidebar.list-of-premiums',
          iconName: 'shopping_cart',
          route: '/awards/list',
          exactPath: true,
        },
        {
          displayName: 'sidebar.companies',
          iconName: 'card_giftcard',
          route: '/awards/campaigns',
          exactPath: true,
        },
        {
          displayName: 'sidebar.premiums-archive',
          iconName: 'restore',
          route: '/awards/archive',
          exactPath: true,
        },
        {
          displayName: 'sidebar.list-points',
          iconName: 'timeline',
          route: '/awards/list-points',
          exactPath: true,
        },
      ],
    },
    {
      displayName: 'sidebar.pooling',
      iconName: 'directions_car_filled',
      route: '/pooling',
      exactPath: false,
      moduleName: 'mpooling',
      children: [
        {
          displayName: 'sidebar.configuration',
          iconName: 'settings',
          route: '/pooling/configuration',
          exactPath: true,
          moduleName: 'mpooling',
        },
        {
          displayName: 'sidebar.statistics',
          iconName: 'bar_chart',
          route: '/pooling/statistics',
          exactPath: true,
          moduleName: 'mpooling',
        },
        {
          displayName: 'sidebar.visits',
          iconName: 'directions_car',
          route: '/pooling/trips',
          exactPath: true,
          moduleName: 'mpooling',
        },
      ],
    },
    {
      displayName: 'sidebar.smart-working',
      iconName: 'laptop',
      route: '/smartworking',
      exactPath: false,
      moduleName: 'sworking',
      children: [
        {
          displayName: 'sidebar.team',
          iconName: 'groups',
          route: '/smartworking/teams',
          exactPath: true,
          moduleName: 'sworking',
        },
        {
          displayName: 'sidebar.configuration',
          iconName: 'settings',
          route: '/smartworking/configuration',
          exactPath: true,
          moduleName: 'sworking',
        },
        {
          displayName: 'sidebar.statistics',
          iconName: 'ballot',
          route: '/smartworking/statistics',
          exactPath: true,
          moduleName: 'sworking',
        },
        {
          displayName: 'sidebar.history',
          iconName: 'history_toggle_off',
          route: '/smartworking/history',
          exactPath: true,
          moduleName: 'sworking',
        },
        {
          displayName: 'sidebar.feedback',
          iconName: 'history_toggle_off',
          route: '/smartworking/feedback',
          exactPath: true,
          moduleName: 'sworking',
        },
      ],
    },
    {
      displayName: 'sidebar.coworking',
      iconName: 'business',
      route: '/coworking',
      exactPath: false,
      moduleName: 'coworking',
      children: [
        {
          displayName: 'sidebar.transactions',
          iconName: 'payment',
          route: '/coworking/transactions',
          exactPath: false,
          moduleName: 'coworking',
        },
        {
          displayName: 'sidebar.installments',
          iconName: 'payments',
          route: '/coworking/installments',
          exactPath: false,
          moduleName: 'coworking',
        },
      ],
    },
    {
      displayName: 'sidebar.workstations',
      iconName: 'desktop_windows',
      route: '/stations',
      exactPath: false,
      moduleName: 'sworking',
      children: [
        {
          displayName: 'sidebar.workstations-setup',
          iconName: 'architecture',
          route: '/stations/workstations',
          exactPath: false,
          moduleName: 'workstations',
        },
        {
          displayName: 'sidebar.configuration',
          iconName: 'settings',
          route: '/stations/configuration',
          exactPath: true,
          moduleName: 'sworking',
        },
      ],
    },
    {
      displayName: 'sidebar.sharing',
      iconName: 'touch_app',
      route: '/sharing',
      exactPath: false,
      moduleName: 'sharing',
      children: [
        {
          displayName: 'sidebar.transactions',
          iconName: 'payment',
          route: '/sharing/transactions',
          exactPath: false,
          moduleName: 'sharing',
        },
        {
          displayName: 'sidebar.installments',
          iconName: 'payments',
          route: '/sharing/installments',
          exactPath: false,
          moduleName: 'sharing',
        },
      ],
    },
    // {
    //   displayName: 'sidebar.questionnaires',
    //   iconName: 'format_list_bulleted',
    //   route:'/surveys',
    //   exactPath: true,
    // },
    {
      displayName: 'sidebar.questionnaires',
      iconName: 'format_list_bulleted',
      route: '/surveys',
      exactPath: false,
      moduleName: 'survey',
      children: [
        {
          displayName: 'dashboard.surveys.surveys-list',
          iconName: 'format_list_bulleted',
          route: '/surveys/surveys',
          exactPath: true,
          moduleName: 'survey',
        },
        {
          displayName: 'sidebar.configuration',
          iconName: 'settings',
          route: '/surveys/configuration',
          exactPath: true,
          moduleName: 'survey',
        },
      ],
    },
    {
      displayName: 'sidebar.activities',
      iconName: 'transfer_within_a_station',
      route: '/activities',
      exactPath: false,
      moduleName: 'activity',
      children: [
        {
          displayName: 'sidebar.list-of-activities',
          iconName: 'format_list_bulleted',
          route: '/activities/list',
          exactPath: true,
          moduleName: 'activity',
        },
        {
          displayName: 'sidebar.configuration',
          iconName: 'settings',
          route: '/activities/configuration',
          exactPath: true,
          moduleName: 'activity',
        },
      ],
    },
    {
      displayName: 'sidebar.profile',
      iconName: 'person',
      route: '/profile',
      exactPath: true,
    },
  ];
  constructor(
    private dialog: MatDialog,
    private clientsService: ClientsService,
    private changeDetection: ChangeDetectorRef,
    private store: Store<AppState>
  ) {}

  ngOnInit(): void {
    // this.store
    //   .select(selectModules)
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((modules) => {
    //     this.myActiveModules = modules;
    //     this.changeDetection.detectChanges();
    //   });
  }

  // hasActiveModule(moduleCode: string): boolean {
  //   return this.myActiveModules.some((m) => m.code === moduleCode && m.active);
  // }

  modalExit(): void {
    const dialogRef = this.dialog.open(ModalExitComponent, {
      width: '420px',
    });

    // dialogRef.afterClosed().subscribe((result) => {
    //   if (result) {
    //     this.store.dispatch(AuthActions.onLogout());
    //   }
    // });
  }

  menuClick(): void {
    this.sidebarOpened = !this.sidebarOpened;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
